import * as React from 'react';

import './icon-styles.css';

export const SaveIcon = () => {
    return (
        <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
        >
            <g className="icon-save-1">
                <polygon
                    className="icon-style icon-stroke"
                    points="8 24 24 24 24 11.2 20.8 8 8 8 8 24"
                />
                <rect
                    className="icon-style icon-stroke"
                    x="11"
                    y="17"
                    width="10"
                    height="7"
                />
                <rect
                    className="icon-style icon-stroke"
                    x="12"
                    y="8"
                    width="8"
                    height="5"
                />
                <line className="icon-style icon-stroke" x1="17" y1="10" x2="17" y2="8" />
            </g>
        </svg>
    );
};



// WEBPACK FOOTER //
// ./src/App/shared/icons/pt-icon-save.tsx